<template>
	<a :href="url" :target="target">
		<div class="c-teaser-gallery-intro__wrapper">
			<div class="c-teaser-gallery-intro__inner">
				<div class="c-teaser-gallery-intro__bg" :style="{ background: `url(${image}) no-repeat` }"></div>
				<div class="c-teaser-gallery-intro__content">
					<v-icon :name="icon" size="xxl" />
					<h2 class="c-teaser-gallery-intro__heading">{{ heading }}</h2>
					<p>{{ text }}</p>
					<div class="c-teaser-gallery-intro__content--arrow">
						<v-icon name="icon-chevron" size="3" />
					</div>
				</div>
			</div>
		</div>
	</a>
</template>

<script>
import VIcon from "../../components/icon/VIcon.vue";
export default {
	name: "VTeaserGalleryIntro",
	components: {
		VIcon
	},
	props: {
		icon: {
			type: String,
			default: 'icon-map'
		},
		image: {
			type: String
		},
		heading: {
			type: String
		},
		text: {
			type: String
		},
		target: {
			type: String,
			default: "_blank"
		},
		url: {
			type: String
		}
	},
	data() {
		return {};
	},
	computed: {},
	methods: {}
};
</script>
